// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"25bc2281","613":"dc5f7679","986":"81d4fee9"}[chunkId] + ".chunk.js";
};